export function TypingIndicator() {
    return (
        <div className="ml-2 mt-4 relative flex max-w-fit">
            <div className="absolute left-0 bottom-1 w-2 h-2 transform -translate-x-2 translate-y-1">
                <div className="absolute w-2 h-2 bg-gray-200 rounded-full"></div>
            </div>
            <div className="flex items-center gap-1 w-full h-8 bg-gray-200 rounded-full p-2">
                <div className="w-2 h-2 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: "0ms" }} />
                <div className="w-2 h-2 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: "200ms" }} />
                <div className="w-2 h-2 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: "400ms" }} />
            </div>
        </div>
    )
}

interface LightTypingIndicatorProps {
    content: string
}
export function LightTypingIndicatorMemo({ content }: LightTypingIndicatorProps) {
    return (
        <div className="flex items-center gap-1 w-full h-2 text-xl text-gray-500 font-medium">
            <div className="animate-pulse" style={{ animationDelay: "0ms" }}>
                {content}
            </div>
            <div className="size-3 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: "200ms" }} />
            <div className="size-3 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: "400ms" }} />
            <div className="size-3 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: "600ms" }} />
        </div>
    )
}

interface ShimmerTextProps {
    children: React.ReactNode
}
export function ShimmerText({ children }: ShimmerTextProps) {
    return (
        <span className="relative inline-block align-middle">
            <span className="relative z-10 text-inherit">{children}</span>
            <span
                aria-hidden="true"
                className="absolute inset-0 z-20 pointer-events-none"
                style={{
                    background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%)",
                    backgroundSize: "200% 100%",
                    animation: "shimmerOverlay 2s linear infinite",
                }}
            />
            <style>
                {`
                    @keyframes shimmerOverlay {
                        0% { background-position: -200% 0; }
                        100% { background-position: 200% 0; }
                    }
                `}
            </style>
        </span>
    )
}
